import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container } from "react-bootstrap";
import { logger } from "../../Utils";
import { ModalBox, PDFViewerComponent } from "../../App/components";
import Layout from "../components/Layout";
import { getResourceData, responsive, getcardNum,getQueryParam } from "./helpers";
import "./style.scss";
import FormsCardList from "./formsCardList";
import { Helmet } from "react-helmet";

const LandloadResource = (props) => {
  const [showLoader, setShowLoader] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [formsList, setFormsList] = useState([]);
  const [numberOfCards, setNumberOfCards] = useState(3);
  const [isDesktop, setIsDesktop] = useState(false);
  const queryParam = getQueryParam(window.location.search,'for');

  useEffect(() => {
    window.addEventListener("resize", resize);
    resize();
    getInitialData();
  }, []);

  const getInitialData = async () => {
    const data = { "category": "Landlord Forms" };
    setShowLoader(true);
    const formsList = await getResourceData(`/cms/forms/list`, data);
    setShowLoader(false);
    setFormsList(formsList);
  };

  const resize = () => {
    const { cardNum, isDesktop } = getcardNum;
    setNumberOfCards(cardNum);
    setIsDesktop(isDesktop);
  };

  return (
    <>
    <Helmet>
      <title> {queryParam.toLowerCase().includes('tenant') ? 'Tenant Forms | Rent Panda'
              :  queryParam.toLowerCase().includes('landlord') 
              ? 'Landlord Forms | Rent Panda' : ''}</title>
      <meta name="description" content="Rent Panda provides free resources, like our forms, 
      available for you with the latest know-how for renting." />
    </Helmet>
    <div className="ResourcesPage">
      <Layout newHeader={true}>
        <div className="ResourcesPage-header">
          <Container>
            <div className="main-heading text-left text-md-center text-transform-lowercase">
              {queryParam.toLowerCase().includes('tenant') ? 'Tenant forms and information'
              :  queryParam.toLowerCase().includes('landlord') 
              ? 'landlord forms and information' : ''}
            </div>
            <div className="sub-heading text-left text-md-center">
              {queryParam.toLowerCase().includes('tenant') ? "We've compiled all the forms you may need as a tenant, so you don't have to go digging."
              : queryParam.toLowerCase().includes('landlord')
              ? "We've compiled all the forms you may need as a landlord, so you don't have to go digging.":''}              
            </div>
          </Container>
        </div>

        <div className="ResourcesPage-contentBox">
          <FormsCardList
            formsList={formsList}
            showLoader={showLoader}
            setPdfModal={(val) => setPdfModal(val)}
            setPdfUrl={(pdf) => setPdfUrl(pdf)}
          />

        </div>
      </Layout>

      <ModalBox
        show={pdfModal}
        onHide={() => setPdfModal(false)}
        size="xl"
        className="cu-full-modal"
      >
        <PDFViewerComponent PDFUrl={pdfUrl && pdfUrl} />
      </ModalBox>
    </div>
    </>
  );
};

export default withRouter(LandloadResource);
